import React, { useContext, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { initFacebookPixel } from '../pixel';
import CategoryProducts from './CategoryProducts';
import Category from './Category';
import { ProductContext } from '../context/ProductsContext';
import { HeaderContext } from '../context/HeaderContext';
import { config } from '../config';
import axios from 'axios';
import BannerSlider from '../components/Home/BannerSlider';

const ProductPage = () => {
  const { loading: productLoading, banners } = useContext(ProductContext);
  const { loading: headerLoading } = useContext(HeaderContext);

  const apiUrl = config.apiUrl;


  // যদি যেকোনো একটি কনটেক্স্ট লোডিং অবস্থায় থাকে
  if (productLoading || headerLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-white">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-green-500"></div>
      </div>
    );
  }
  
  return (
    <>
      <div className="bg-gray-50">
        <Header />
        {/* <div className="container mx-auto px-4 py-8">
          <BannerSlider banners={banners} />
        </div> */}
        {banners.length > 0 && <BannerSlider banners={banners} />}
        <Category />
        <CategoryProducts />
        <Footer />
      </div>
    </>
  );
};

export default ProductPage;